import { menuItems } from '../../../mocks/menuData';
import { Link } from 'react-router-dom';

const Menu = () => {
  const categories = [
    { id: 'bocadillos', name: 'Bocadillos kebab' },
    { id: 'durum', name: 'Durum clásicos' },
    { id: 'pollo', name: 'Pollo frito' },
    { id: 'platos', name: 'Platos kebab' },
    { id: 'raciones', name: 'Raciones' },
    { id: 'menus', name: 'Menús familiares' },
    { id: 'bebidas', name: 'Bebidas' }
  ];

  // Featured items con las imágenes reales del menú
  const featuredItems = [
    {
      id: 27,
      name: 'Menú Bocadillo Kebab',
      description: 'Bocadillo de kebab + Patatas + Bebida',
      price: '8,50€',
      image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/a1fe67f0cf36ec0a9c9a79a844dd85f0.jpeg'
    },
    {
      id: 32,
      name: 'Menú Plato Kebab',
      description: 'Plato kebab + Patatas + Bebida',
      price: '9,00€',
      image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/255efbce8e4dbecc4e8a75cf55add4ff.jpeg'
    },
    {
      id: 8,
      name: 'Durum',
      description: 'Enrollado de ternera o pollo en pan de pita con ensalada y salsas',
      price: '6,50€',
      image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/0fc96b86069ca05b9deda0f399561d59.jpeg'
    }
  ];

  return (
    <section id="menu" className="py-20 bg-[#E63946]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Nuestro Menú
          </h2>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Descubre nuestra selección de kebabs, durums, pollo frito y mucho más
          </p>
        </div>

        {/* Featured Items */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {featuredItems.map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
            >
              <div className="w-full h-64 overflow-hidden">
                <img 
                  src={item.image} 
                  alt={item.name}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.name}</h3>
                <p className="text-gray-600 text-sm mb-4">{item.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-white">{item.price}</span>
                  <a 
                    href="tel:919123048"
                    className="bg-gray-900 text-white px-6 py-2 rounded-full font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Pedir ahora
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mb-16">
          <Link 
            to="/menu"
            className="inline-block bg-gray-800 text-white px-6 py-3 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-gray-700 transition-colors"
          >
            Ver todo el menú
          </Link>
        </div>

        {/* Categories */}
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 md:p-12">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center">
            Categorías Completas
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {categories.map((category) => (
              <Link
                key={category.id}
                to="/menu"
                className="bg-white/20 backdrop-blur-sm px-4 py-3 rounded-xl text-center font-semibold text-white hover:bg-white hover:text-[#E63946] transition-colors cursor-pointer whitespace-nowrap"
              >
                {category.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Menu;
